
export default {
    setProficiencia(state, data) {
        state.proficiencia = data
    },
    setProficiencias(state, data) {
        state.proficiencias = data
    }
}